export const getAreaQuantity = (area) => {
  if (area.quantity != null) {
    const q = Number(area.quantity);
    return Number.isFinite(q) && q >= 0 ? q : 0;
  }

  const sq = Array.isArray(area.squareFootages) ? area.squareFootages : [];
  const q0 = sq[0]?.quantity;
  const q = Number(q0);
  return Number.isFinite(q) && q >= 0 ? q : 0;
};

export const normalizeTaskFromBackend = (task) => {
  return {
    ...task,
    active: typeof task.active === "boolean" ? task.active : true,
    note: typeof task.note === "string" ? task.note : "",
  };
};

export const normalizeAreaFromBackend = (area) => {
  const quantity = getAreaQuantity(area);

  return {
    ...area,

    squareFootages:
      Array.isArray(area?.squareFootages) && area.squareFootages.length > 0
        ? area.squareFootages.map((item, index) =>
            index === 0
              ? {
                  ...item,
                  quantity,
                }
              : item,
          )
        : [
            {
              quantity,
            },
          ],

    tasks: Array.isArray(area.tasks) ? area.tasks.map(normalizeTaskFromBackend) : [],
  };
};

export const findAreaInWorkflow = (state, areaUid) => {
  return state.sectorWorkflow.areas.find((a) => a.uid === areaUid) || state.sectorWorkflow.otherAreas.find((a) => a.uid === areaUid);
};
